<template>
  <div>
    <b-container>
      <transition name="fade">
        <ProductsList scope="lh" :total="getTotal" :selected-product-data="getProduct" :selected-product-docs="getDocs" :products="getProducts" @on-product-select="showProduct(...arguments)" @on-click-load-more="loadMore">
          <template #ingress>
            <h2 class="d-print-none">{{ products_lashus_title }}</h2>
            <p class="d-print-none">{{ products_lashus_text }}</p>
          </template>
        </ProductsList>
      </transition>
    </b-container>
  </div>
</template>

<script>
  import store from "@/store/store";
  import { mapGetters, mapActions } from "vuex";
  import productsListMixin from "@/mixins/productsListMixin";
  import contentMixin from "@/mixins/contentMixin";
  export default {
    name: "ProductsListViewLH",
    mixins: [productsListMixin, contentMixin],
    computed: {
      ...mapGetters("productsLH", ["getProducts", "getCount", "getTotal"]),
      ...mapGetters("productLH", ["getProduct", "getDocs"]),
    },
    methods: {
      ...mapActions("productsLH", ["fetchProducts"]),
      ...mapActions("productLH", ["fetchProduct", "fetchDocsForArt"]),
      loadMore() {
        this.$store.dispatch("productsLH/updateSkip");
      },
    },
    beforeRouteEnter(to, from, next) {
      // Reset pagination
      store.dispatch("productsLH/resetSkip");
      // Reset selected product
      store.dispatch("productLH/resetProduct");
      store
        .dispatch("productsLH/fetchProducts")
        .then(() => next())
        .catch((error) => {
          if (error.response && error.response.status == 404) {
            next({ name: "404", params: { resource: "event" } });
          } else {
            next({ name: "network-issue" });
          }
        });
    },
    beforeRouteUpdate(to, from, next) {
      store.dispatch("productsLH/fetchProducts").then(() => {
        next();
      });
    },
  };
</script>

<style lang="scss" scoped></style>
